export const defaultMetrics = {
  programCount: 0,
  weeklyReviewedApplicationCount: 0,
  monthlyReviewedApplicationCount: 0,
  assignedPendingApplicationCount: 0,
}
